import { Component, Input, OnInit } from '@angular/core';
import { Constants } from '../../utilities/Constants';

@Component({
  standalone: false,
  selector: 'mm-ach-confirm-message',
  templateUrl: './ach-confirm-message.component.html',
  styleUrls: ['./ach-confirm-message.component.scss']
})
export class AchConfirmMessageComponent implements OnInit {
  @Input() isNewRecurringProfile: boolean;
  @Input() isNewOnRequestProfile: boolean;
  newProfileText: string; //only shown when new profile is created
  newAchTransferText: string = Constants.defaultPendDescription; //shown for all ACH transfers

  constructor() { }

  ngOnInit(): void {
    this.newProfileText = this.newProfileConfirmationText();
  }

  newProfileConfirmationText() {
    if (this.isNewRecurringProfile) {
      return Constants.newRecurringAchProfileConfirmation;
    }
    else if (this.isNewOnRequestProfile) {
      return Constants.newOnRequestAchProfileConfirmation;
    }
    return '';
  }

}
